export default {
  convertNumberToMoneyFormat(number) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/helper/convert_number_to_money_format', { number });
  },
};

